<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="区域调整台账"
      width="85%"
      top="6vh"
      append-to-body>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="sd/salesRevenueReport/adjustLog">
      <div slot="toolbar">
        <el-button type="primary" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="区域">
            <el-input v-model.trim="filter.departmentName" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectDepartment.open()">选择</el-button>
            </el-input>
            <department-select ref="selectDepartment" @select="selectDepartment"/>
          </vm-search>
          <vm-search label="调整类型">
            <el-select v-model="filter.adjustType" clearable placeholder="请选择" style="width: 150px">
              <el-option :value="1" label="增加"/>
              <el-option :value="2" label="减少"/>
            </el-select>
          </vm-search>
          <vm-search label="开始月份">
            <el-date-picker v-model="filter.beginTime" value-format="yyyy-MM-dd" type="month" style="width: 140px"/>
          </vm-search>
          <vm-search label="结束月份">
            <el-date-picker v-model="filter.endTime" value-format="yyyy-MM-dd" type="month" style="width: 140px"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="departmentName" align="center" label="区域名称" min-width="140"/>
      <el-table-column prop="periodDate" align="center" label="期间" width="120"/>
      <el-table-column prop="adjustTypeName" align="center" label="调整类型" width="110"/>
      <el-table-column prop="adjustAmount" align="center" label="调整金额" width="120"/>
      <el-table-column prop="reason" align="center" label="调整原因" min-width="160"/>
      <el-table-column prop="createBy" align="center" label="操作人" width="100"/>
      <el-table-column prop="createTime" align="center" label="操作时间" width="160"/>
      <el-table-column v-if="$auth(713)" label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "AdjustLogDialog",
    components: {VmTable, VmSearch, DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        exportLoading: false,
        filter: {
          departmentId: "",
          departmentName: "",
          adjustType: "",
          beginTime: "",
          endTime: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      remove(row) {
        this.$confirm("确定删除该区域调整记录吗? 删除后该区域该期间的签收金额将恢复为系统实际金额。", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "sd/salesRevenueReport/deleteAdjustLog", null, {pkid: row.pkid})
            .then(resp => {
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "删除失败");
              }
              this.$message.success("删除成功");
              this.getList(-1);
              this.$emit("deleted");
            });
        }).catch(() => {});
      },
      selectDepartment(row) {
        this.filter.departmentId = row.departmentID;
        this.filter.departmentName = row.departmentName;
      },
      exportData() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        delete params.departmentName;
        this.$http
          .postForFile("basic", "sd/salesRevenueReport/exportAdjustLog", params)
          .then(resp => {
            this.exportLoading = false;
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
